import axios from "axios";
import { useEffect, useState, useRef } from "react";
import Result from "../components/PositionLogResult";
import Header from "../components/Header";
import PageSelect from "../components/PageSelect";
import ExcelJS from 'exceljs';
import positionResultType from "../model/positionResultType";
import clusterMasterResultType from "../model/ClusterMasterResultType";
import "./PositionLog.css";

const PositionLog = () => {

    const [apiKey, setApikey] = useState<string>("");
    const [mounted, setMounted] = useState<string>("beacon");
    const [deviceid, setDeviceId] = useState<string>("");
    const [beacon_id, setBeacon_Id] = useState<string>("");
    const [per_page, setPer_Page] = useState<string>("");
    const [cluster_id, setCluster_Id] = useState<string>("");
    const [detected_gt, setDetcted_gt] = useState<string>("");
    const [detected_lt, setDetcted_lt] = useState<string>("");
    const [sort, setSort] = useState<string>("");
    const [pageNo, setPageNo] = useState<number>(0);
    const [lastPageNo, setLastPageNo] = useState<number>(0);
    const [period, setPeriod] = useState<string>("1")
    const [total, setTotal] = useState<number>(-1);
    const [result, setResult] = useState<positionResultType[]>([]);
    const results: positionResultType[] = [];
    const [csvResult, setCSVResult] = useState<positionResultType[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);            // CSV全件取得
    const [isPositionLoading, setIsPositionLoading] = useState<boolean>(false); // Position生成
    const [isNoCheck, setNoCheck] = useState<boolean>(false);
    var apiUrl:string = "";
    let clusterApiUrl: string = ""
    let clusterApikey: string = ""
    const clusterResults: clusterMasterResultType[] = [];
    const [clusterResult, setClusterResult] = useState<clusterMasterResultType[]>([]);
    const CLUSTER_PLACEFORDER: string = "クラスタを選択して下さい";

    // ---- UI-only state ----
    const [filterOpen, setFilterOpen] = useState<boolean>(true);
    const [csvOpen, setCsvOpen] = useState<boolean>(false);
    const csvRef = useRef<HTMLDivElement>(null);

    const checkLocoEnv = () => {
      if (localStorage.getItem("locoEnv") === "prod") {
        apiUrl = "https://api.bc-loco.jp/api/position_logs"
        clusterApiUrl = "https://api.bc-loco.jp/api/clusters"
      } else {
        apiUrl = "http://stg.api.bc-loco.jp/api/position_logs"
        clusterApiUrl = "http://stg.api.bc-loco.jp/api/clusters"
      }
    }

    const getCluster = async() => {
      await axios.get(clusterApiUrl,
      {
        headers: {
            "Authorization": clusterApikey,
            "Content-Type": "application/json"
        },
        params: {
          ...({per_page: 1000})
        }
      })
      .then(async res => {
        console.log(res);
        if(res.data.code === 400) {
          alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
          return
        } else if(res.data.code === 401) {
          alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
          return
        }
        const items = JSON.parse(JSON.stringify(res.data.payload))
        console.log(items)

        clusterResult.length = 0
        items.data.forEach((value: clusterMasterResultType) => {
          clusterResults.push(value)
        })

        setClusterResult(clusterResults)

        const selectCluster = document.getElementById("cluster") as HTMLSelectElement;

        //Cluster一覧を全て消去
        let maxOptionLength = selectCluster.options.length;
        for ( let idx = maxOptionLength ; idx > 0 ; idx-- ) {
          console.log("maxoption:" + maxOptionLength)
          selectCluster.options.remove(idx)
        }

        //Clusterを設定
        clusterResults.forEach((value: clusterMasterResultType, index: number) => {

          let insertClusterNameflg: Boolean = true;
          for ( let idx = 0 ; idx < selectCluster.options.length ; idx++ ) {
              if (selectCluster.options[idx].textContent === value.name) {
                insertClusterNameflg = false;
              }
          }

          if (insertClusterNameflg) {
            console.log(value.name)
            const option1 = document.createElement("option");
            option1.value = index.toString();
            option1.textContent = value.name;
            selectCluster?.appendChild(option1)
          }
        })
      })
      .catch(err =>
        ClusterError(err)
      )
  }

    const getPositionLog = async(e: any, pageNo: number) => {
        e.preventDefault();
        if (per_page === "") {
          setPer_Page("100")
        }
        saveParams();
        saveApikey();
        checkLocoEnv();
        if (Number(period) > 60 || Number(period) < 1) {
          alert("集計期間は1秒から60秒の範囲で入力してください。")
          return
        }
        if (cluster_id == "") {
          alert("クラスタを選択してください。")
          return
        }
        setIsPositionLoading(true);

        await axios.get(apiUrl,
        {
          headers: {
              "Authorization": apiKey,
              "Content-Type": "application/json"
          },
          params: {

            ...(mounted ? {mounted: mounted} : {}),
            ...(deviceid ? {device_id: deviceid} : {}),
            ...(cluster_id ? {cluster_id: cluster_id} : {}),
            ...(beacon_id ? {beacon_id: beacon_id} : {}),
            ...(pageNo ? {page: pageNo} : {}),
            ...(per_page ? {per_page: per_page} : {}),
            ...(period ? {period: period} : {}),
            ...(detected_gt ? {detected_gt: detected_gt.replace("T", " ")} : {}),
            ...(detected_lt ? {detected_lt: detected_lt.replace("T", " ")} : {}),
            ...(sort ? {sort: sort} : {})
          }

        })
        .then(async res => {
          console.log(res);
          if(res.data.code === 400) {
            alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
            setIsPositionLoading(false);
            return
          } else if(res.data.code === 401) {
            alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
            setIsPositionLoading(false);
            return
          }
          const items = JSON.parse(JSON.stringify(res.data.payload))

          if (items.total > 100000) {
            if (pageNo === 0) {
              alert("10万件を超えるデータは表示出来ません\n10万件までのデータを表示します\n総件数:" + items.total + "\n日付範囲を調整して下さい。")
            }

            setTotal(items.total)
            setPageNo(items.current_page)
            setLastPageNo(getLastPageNo())
            //return
          } else {
            setTotal(items.total)
            setPageNo(items.current_page)
            setLastPageNo(items.last_page)
          }

          items.data.forEach((value: positionResultType, index: number) => {
            results.push(value)
            results[index].no = items.from;
            items.from++;
          })
          setIsPositionLoading(false);
          setResult(results)
        })
        .catch(err =>
          PositionError(err)
        )
    }

    const createCSV = async (e: React.MouseEvent<HTMLElement, MouseEvent>) => {

      const workbook = new ExcelJS.Workbook();
      workbook.addWorksheet("positionLog");
      const worksheet = workbook.getWorksheet("positionLog");
      const columns: Partial<ExcelJS.Column>[] = [];

      if (isNoCheck) {
        columns.push({ header: "no", key: "no" })
      }
      columns.push({ header: "cluster_id", key: "cluster_id" })
      if (mounted === "beacon") {
        columns.push({ header: "device_id", key: "device_id" })
      } else {
        columns.push({ header: "beacon_id", key: "beacon_id" })
      }

      columns.push({ header: "nearest", key: "nearest" })
      columns.push({ header: "x", key: "x" })
      columns.push({ header: "y", key: "y" })
      columns.push({ header: "h", key: "h" })
      columns.push({ header: "r", key: "r" })
      columns.push({ header: "detected", key: "detected" })

      worksheet.columns = columns;
      setIsLoading(true);
      if (await getAllPositionLog(e, 1) === true) {

        csvResult.forEach((value: positionResultType) => {
          worksheet.addRow(value);
        });

        csvResult.length = 0;

        console.log("Row Count:" + worksheet.rowCount)
        setIsLoading(false);

        try {
          const uint8Array = await workbook.csv.writeBuffer();
          const blob = new Blob([uint8Array], { type: 'application/octet-binary' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          setTimeout(()=> {
            a.href = url;
            a.download = "positionlog_" + getNowDate() +  ".csv";
            a.click();
            a.remove();
          },1000)

        } catch (error) {
          console.error(error);
        }
      } else {
        setIsLoading(false);
      }

    }

    const getAllPositionLog = async(e: any, pageNo: number) => {
      let ret = true;
      e.preventDefault();
      checkLocoEnv();
      if (Number(period) > 60 || Number(period) < 1) {
        alert("集計期間は1秒から60秒の範囲で入力してください。")
        return
      }
      if (cluster_id == "") {
        alert("クラスタを選択してください。")
        return
      }
      await axios.get(apiUrl,
      {
        headers: {
            "Authorization": apiKey,
            "Content-Type": "application/json"
        },
        params: {
          ...(mounted ? {mounted: mounted} : {}),
          ...(deviceid ? {device_id: deviceid} : {}),
          ...(cluster_id ? {cluster_id: cluster_id} : {}),
          ...(beacon_id ? {beacon_id: beacon_id} : {}),
          ...(pageNo ? {page: pageNo} : {}),
          ...({per_page: 1000}),
          ...(period ? {period: period} : {}),
          ...(detected_gt ? {detected_gt: detected_gt.replace("T", " ")} : {}),
          ...(detected_lt ? {detected_lt: detected_lt.replace("T", " ")} : {}),
          ...(sort ? {sort: sort} : {})
        }
      })
      .then(async res => {
        console.log(res);
        if(res.data.code === 400) {
          alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
          return ret = false
        } else if(res.data.code === 401) {
          alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
          return ret = false
        }
        const items = JSON.parse(JSON.stringify(res.data.payload))
        if (items.total > 100000) {
          if (pageNo === 1) {
            let result = window.confirm("10万件を超えるデータは出力出来ません\n10万件までのデータを出力しますか？\n総件数:" + items.total + "\n日付範囲を調整して下さい。")
            if (result === false) {
              return ret = false
            }
          }
        } else {
          setLastPageNo(items.last_page)
        }
        let csvArrayCount = csvResult.length;

        items.data.forEach((value: positionResultType, index: number) => {
          csvResult.push(value);
          csvResult[index + csvArrayCount].no = items.from;
          items.from++;
        })
        setCSVResult(csvResult);
        if (items.last_page > 100) {
          if (items.current_page != 100) {
            await getAllPositionLog(e, items.current_page + 1);
          } else {
            console.log("getall: " + csvResult.length);
          }
        } else {
          if (items.current_page != items.last_page) {
            await getAllPositionLog(e, items.current_page + 1);
          } else {
            console.log("getall: " + csvResult.length);
          }
        }
      })
      .catch(err =>
        alert("エラーが発生しました。" + err)
      )
      return ret
  }

  const PositionError = (err: any) => {
    setIsPositionLoading(false);
    alert("エラーが発生しました。" + err);
  }

  const ClusterError = (err: any) => {
    setApikey("");
    clearSelectCluster();
    alert("クラスター取得でエラーが発生しました。Staging・Productionの設定は合ってますか？" + err);
  }

  const clearSelectCluster = () => {
    const selectCluster = document.getElementById("cluster") as HTMLSelectElement;
    let maxOptionLength = selectCluster.options.length;
    for ( let idx = maxOptionLength ; idx > 0 ; idx-- ) {
      console.log("maxoption:" + maxOptionLength)
      selectCluster.options.remove(idx)
    }
  }

  const changeDetectedGt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setDetcted_gt(value);
  }
  const changeDetectedLt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setDetcted_lt(value);
  }
  const changeMounted = (value: string) => {
    setMounted(value);
    setResult([]);
  }

  const getNowDate = () => {
    let dt = new Date();
    let y = dt.getFullYear();
    let m = ("00" + (dt.getMonth()+1)).slice(-2);
    let d = ("00" + (dt.getDate())).slice(-2);
    return y + m + d;
  }

  const getLastPageNo = () => {
    if (per_page === "") { return 100000 / 100 }
    else { return 100000 / Number(per_page) }
  }

  type positionParamsType = {
    apikey?: string, deviceid?: string, clusterid?: string, beaconid?: string, mounted?: string,
    perpage?: string, detectedgt?: string, detectedlt?: string, sort?: string
  }

  const saveParams = () => {
    let params: positionParamsType = {};
    params.deviceid = deviceid ? deviceid : "";
    params.perpage = per_page ? per_page : "";
    params.beaconid = beacon_id ? beacon_id : "";
    params.detectedgt = detected_gt ? detected_gt : "";
    params.detectedlt = detected_lt ? detected_lt : "";
    params.sort = sort ? sort : "";

    let json = JSON.stringify(params);
    console.log("params:" + json);
    localStorage.setItem("locoPositionParams", json)
  }

  const saveApikey = () => {
    localStorage.setItem("locoApikey", apiKey ? apiKey : "" );
  }

  const loadParams = () => {
    const paramsJson = localStorage.getItem("locoPositionParams")
    if (paramsJson != null) {
      const params:positionParamsType = JSON.parse(paramsJson as string)
      setDeviceId(params.deviceid ? params.deviceid : "");
      setPer_Page(params.perpage ? params.perpage : "")
      setBeacon_Id(params.beaconid ? params.beaconid : "");
      setDetcted_gt(params.detectedgt ? params.detectedgt : "");
      setDetcted_lt(params.detectedlt ? params.detectedlt : "");
      setSort(params.sort ? params.sort : "");
    }
  }

  const loadApikey = () => {
    const locoApikey = localStorage.getItem("locoApikey")
    if (locoApikey != null) {
      clusterApikey = locoApikey;
      setApikey(locoApikey ? locoApikey : "");
    }
  }

  const setSelectApikey = () => {
    const secretJson = localStorage.getItem("locoSecretArray")
    if (secretJson != null) {
      const secret = JSON.parse(secretJson as string)

      const selectApikey = document.getElementById("apikey") as HTMLSelectElement;
      const option1 = document.createElement("option");
      option1.value = "";
      option1.textContent = "APIKeyを選択して下さい";
      selectApikey?.appendChild(option1)

      secret.forEach((element: { apikey: string; name: string | null; }) => {
          const option1 = document.createElement("option");
          option1.value = element.apikey;
          option1.textContent = element.name;
          selectApikey?.appendChild(option1)
      })
    }
  }

  const selectCluster = (clusteridx: string) => {
    setCluster_Id(clusterResult[Number(clusteridx)].id)
  }

  const selectApikey = (selectApikey: string) => {
    clusterApikey = selectApikey;
    setApikey(selectApikey);
    checkLocoEnv();
    getCluster();
  }

  const changePerPage = (value: string) => { setPer_Page(value) }
  const changePeriod = (value: string) => { setPeriod(value); }

  useEffect(() => {
    const secretJson = localStorage.getItem("locoSecretArray")
    if (secretJson != null) { setSelectApikey() }
    loadParams();
    loadApikey();
    checkLocoEnv();
    getCluster();
  },[])

  // close CSV popover on outside click
  useEffect(() => {
    const onClick = (ev: MouseEvent) => {
      if (csvRef.current && !csvRef.current.contains(ev.target as Node)) setCsvOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  // ---- active filter chips (UI only) ----
  type Chip = { key: string; label: string; value: string; clear: () => void };
  const activeChips: Chip[] = [
    apiKey ? { key: "apiKey", label: "ApiKey", value: "設定済み", clear: () => setApikey("") } : null,
    { key: "mounted", label: "Mounted", value: mounted === "beacon" ? "Beacon" : "Device", clear: () => {} },
    (mounted === "beacon" && deviceid) ? { key: "device", label: "Device", value: deviceid, clear: () => setDeviceId("") } : null,
    (mounted === "device" && beacon_id) ? { key: "beacon", label: "Beacon", value: beacon_id, clear: () => setBeacon_Id("") } : null,
    period ? { key: "period", label: "Period", value: period + "s", clear: () => setPeriod("1") } : null,
    detected_gt ? { key: "dgt", label: "Detected ≥", value: detected_gt, clear: () => setDetcted_gt("") } : null,
    detected_lt ? { key: "dlt", label: "Detected ≤", value: detected_lt, clear: () => setDetcted_lt("") } : null,
    sort ? { key: "sort", label: "Sort", value: sort.toUpperCase(), clear: () => setSort("") } : null,
    (per_page && per_page !== "100") ? { key: "pp", label: "Per_Page", value: per_page, clear: () => setPer_Page("100") } : null,
  ].filter(Boolean) as Chip[];

  const resetFilters = () => {
    setDeviceId(""); setBeacon_Id("");
    setDetcted_gt(""); setDetcted_lt("");
    setSort(""); setPer_Page("100"); setPeriod("1");
  };

  return (
    <div className="bl-page">
      <Header current_page="Position"/>

      <div className="bl-shell">
        {/* ---------- Sidebar: filters ---------- */}
        <aside className={"bl-aside" + (filterOpen ? "" : " collapsed")}>
          <div className="bl-aside-head">
            <span className="bl-aside-title"><Ico name="filter"/> 検索条件</span>
            <button type="button" className="bl-btn ghost sm icon" title={filterOpen ? "閉じる" : "開く"}
              onClick={() => setFilterOpen(o => !o)}>
              <Ico name={filterOpen ? "chevronLeft" : "chevronRight"}/>
            </button>
          </div>

          <form id="pl-filter-form" className="bl-aside-body" autoComplete="on" onSubmit={(e) => getPositionLog(e, 0)}>
            <button type="submit" className="bl-btn accent block lg" disabled={isFetchingAny(isPositionLoading, isLoading)}>
              {isPositionLoading ? <><span className="bl-spin-sm" /> 生成中…</> : <><Ico name="search"/> 検索</>}
            </button>

            <div>
              <div className="bl-group-label">接続先・クラスタ</div>
              <div className="bl-fields">
                <div>
                  <label className="bl-field-label">ApiKey</label>
                  <select id="apikey" className="bl-select" value={apiKey} onChange={(e) => selectApikey(e.target.value)} />
                </div>
                <div>
                  <label className="bl-field-label">Cluster_Id</label>
                  <select id="cluster" className="bl-select" onChange={e => selectCluster(e.target.value)}>
                    <option>{CLUSTER_PLACEFORDER}</option>
                  </select>
                </div>
                <div>
                  <label className="bl-field-label">
                    <span>Per_Page</span>
                    <span className="bl-field-hint">既定100 / 最大1000</span>
                  </label>
                  <input className="bl-input" type="text" name="per_page" value={per_page}
                    placeholder="1ページ辺りの最大件数" onChange={(e) => changePerPage(e.target.value)} />
                </div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">基準・識別子</div>
              <div className="bl-fields">
                <div>
                  <label className="bl-field-label">Mounted（固定する側）</label>
                  <select className="bl-select" value={mounted} onChange={e => changeMounted(e.target.value)}>
                    <option value="beacon">Beacon</option>
                    <option value="device">Device</option>
                  </select>
                </div>
                <div>
                  <label className="bl-field-label">
                    <span>Device_Id</span>
                    {mounted !== "beacon" && <span className="bl-field-hint">無視されます</span>}
                  </label>
                  <input className="bl-input bl-mono" type="text" name="deviceId" disabled={mounted !== "beacon"}
                    value={deviceid} placeholder="Device_Idを入力" onChange={(e) => setDeviceId(e.target.value)} />
                </div>
                <div>
                  <label className="bl-field-label">
                    <span>Beacon_Id</span>
                    {mounted !== "device" && <span className="bl-field-hint">無視されます</span>}
                  </label>
                  <input className="bl-input bl-mono" type="text" name="beacon_id" disabled={mounted !== "device"}
                    value={beacon_id} placeholder="Beacon_Idを入力" onChange={(e) => setBeacon_Id(e.target.value)} />
                </div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">集計</div>
              <div className="bl-fields">
                <div>
                  <label className="bl-field-label">
                    <span>Period（集計期間）</span>
                    <span className="bl-field-hint">1〜60秒</span>
                  </label>
                  <input className="bl-input" type="text" name="period" value={period} onChange={(e) => changePeriod(e.target.value)} />
                </div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">Detected（生成時刻）</div>
              <div className="bl-fields">
                <div>
                  <label className="bl-field-label">以降 (gt)</label>
                  <input className="bl-input" type="datetime-local" step="1" autoComplete="on" name="detected_gt"
                    value={detected_gt} onChange={(e) => changeDetectedGt(e.target.value)} />
                </div>
                <div>
                  <label className="bl-field-label">以前 (lt)</label>
                  <input className="bl-input" type="datetime-local" step="1" name="detected_lt"
                    value={detected_lt} onChange={(e) => changeDetectedLt(e.target.value)} />
                </div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">並び順</div>
              <select className="bl-select" value={sort} onChange={e => setSort(e.target.value)}>
                <option value="">ASC / DESC を指定</option>
                <option value="asc">ASC（古い順）</option>
                <option value="desc">DESC（新着順）</option>
              </select>
            </div>

            <div className="bl-aside-actions">
              <button type="submit" className="bl-btn accent block lg" disabled={isPositionLoading || isLoading}>
                {isPositionLoading ? <><span className="bl-spin-sm" /> 生成中…</> : <><Ico name="search"/> 検索</>}
              </button>
              <button type="button" className="bl-btn block" onClick={resetFilters}>Reset</button>
            </div>
          </form>
        </aside>

        {/* ---------- Main ---------- */}
        <main className="bl-main">
          <div className="bl-section-head">
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              {!filterOpen && (
                <button type="button" className="bl-btn ghost sm icon" title="検索条件を開く" onClick={() => setFilterOpen(true)}>
                  <Ico name="filter"/>
                </button>
              )}
              <h2>PositionLog</h2>
              <span className="bl-badge">{mounted === "beacon" ? "Beacon固定" : "Device固定"}</span>
              {total >= 0 && <span className="bl-badge">{total.toLocaleString()} records</span>}
            </div>

            <div className="bl-toolbar">
              <div className="bl-pop-wrap" ref={csvRef}>
                <div className="bl-split">
                  <button type="button" className="bl-btn secondary" onClick={(e) => createCSV(e)} disabled={isPositionLoading || isLoading}>
                    {isLoading
                      ? <><span className="bl-spin-sm" style={{ borderColor: "rgba(0,0,0,.15)", borderTopColor: "var(--bl-accent)" }} /> 出力中…</>
                      : <><Ico name="download"/> CSV出力</>}
                  </button>
                  <button type="button" className="bl-btn secondary" title="CSV出力オプション" onClick={() => setCsvOpen(o => !o)} disabled={isPositionLoading || isLoading}>
                    <Ico name="chevronDown"/>
                  </button>
                </div>
                {csvOpen && (
                  <div className="bl-pop" style={{ width: 220 }}>
                    <div className="bl-pop-title">CSV出力に含める項目</div>
                    <label className="bl-pop-item">
                      <input type="checkbox" checked={isNoCheck} onChange={() => setNoCheck(p => !p)} /> no
                    </label>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Active filters strip */}
          <div className="bl-chips">
            <span className="bl-chips-label">条件</span>
            {activeChips.map(c => (
              <span key={c.key} className="bl-chip">
                <span className="k">{c.label}</span>
                <span className="v bl-mono">{c.value}</span>
                {c.key !== "mounted" && <button type="button" className="x" title="削除" onClick={c.clear}><Ico name="close" size={10}/></button>}
              </span>
            ))}
          </div>

          {/* Results */}
          <div className="bl-results-region">
            {(total > 0 && result.length > 0) ? (
              <>
                <Result result={result} mounted={mounted} />
                <div className="bl-footer">
                  <PageSelect pageNo={pageNo} lastPageNo={lastPageNo} getLog={getPositionLog} />
                </div>
              </>
            ) : (
              <div className="bl-empty">
                <Ico name="database" size={28} />
                <span className="big">{total === 0 ? "該当するログがありません" : "PositionLogを検索"}</span>
                <span>{total === 0 ? "条件を変更して再検索してください" : "クラスタを選択し、左の条件を指定して「検索」を押してください"}</span>
              </div>
            )}

            {(isPositionLoading || isLoading) && (
              <div className="bl-overlay">
                <span className="bl-spin-lg" />
                <span>{isLoading ? "CSV出力中… しばらくお待ちください" : "PositionLog生成中… しばらくお待ちください"}</span>
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  )
}

/* helper for the top button disabled state */
const isFetchingAny = (a: boolean, b: boolean) => a || b;

/* inline icon set — no extra deps */
const Ico = ({ name, size = 14 }: { name: string; size?: number }) => {
  const paths: Record<string, JSX.Element> = {
    filter: <path d="M3 5h18l-7 9v6l-4-2v-4L3 5Z" />,
    search: <><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></>,
    download: <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><path d="m7 10 5 5 5-5" /><path d="M12 15V3" /></>,
    close: <><path d="M18 6 6 18" /><path d="m6 6 12 12" /></>,
    chevronLeft: <path d="m15 18-6-6 6-6" />,
    chevronRight: <path d="m9 18 6-6-6-6" />,
    chevronDown: <path d="m6 9 6 6 6-6" />,
    database: <><ellipse cx="12" cy="5" rx="9" ry="3" /><path d="M3 5v14a9 3 0 0 0 18 0V5" /><path d="M3 12a9 3 0 0 0 18 0" /></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
      {paths[name]}
    </svg>
  );
};

export default PositionLog